import { useState } from "react";

import { Reveal } from "../site/Reveal";

export const VACANCIES = [
  {
    title: "Маркетолог",
    format: "Удалённо · полная занятость",
    lead: "Ведёте маркетинг клиентских проектов: от стратегии до отчёта по заявкам.",
    tasks: [
      "разработка и защита маркетинговых стратегий",
      "работа с performance-каналами и подрядчиками",
      "гипотезы, тесты, рост конверсии и заявок",
      "коммуникация с клиентом и командой проекта",
    ],
    skills: [
      "опыт в digital-маркетинге от 2 лет",
      "понимание воронки, юнит-экономики и метрик",
      "аккуратность в цифрах и умение аргументировать решения",
    ],
  },
  {
    title: "Аналитик",
    format: "Удалённо · полная занятость",
    lead: "Отвечаете за данные: сквозная аналитика, отчётность и выводы для решений.",
    tasks: [
      "настройка систем аналитики и целей",
      "сборка дашбордов и регулярной отчётности",
      "анализ каналов, сегментов и поведения пользователей",
      "подготовка выводов и рекомендаций для команды",
    ],
    skills: [
      "Яндекс Метрика, GA4, сквозная аналитика",
      "уверенная работа с таблицами и BI-инструментами",
      "умение объяснять данные простым языком",
    ],
  },
  {
    title: "PR-manager",
    format: "Удалённо · полная занятость",
    lead: "Развиваете медийное присутствие агентства и клиентских брендов.",
    tasks: [
      "работа со СМИ, отраслевыми площадками и профильными медиа",
      "подготовка публикаций, комментариев и кейсов",
      "развитие собственных каналов агентства",
      "поддержка мероприятий и отраслевых активностей",
    ],
    skills: [
      "опыт в PR или коммуникациях от 2 лет",
      "сильный текст и насмотренность",
      "самостоятельность в поиске инфоповодов",
    ],
  },
];

export function VacanciesList() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="vacancies-list"
      className="mx-auto w-full scroll-mt-[80px] px-5 pt-14 lg:px-[21px] lg:pt-[110px]"
    >
      <Reveal>
        <h2 className="section-title">
          Открытые <span className="text-display-muted">вакансии</span>
        </h2>
      </Reveal>

      <div className="mt-8 border-t border-border lg:mt-[46px]">
        {VACANCIES.map((vacancy, i) => {
          const isOpen = open === i;
          return (
            <div key={vacancy.title} className="border-b border-border">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="group flex w-full items-center gap-5 py-6 text-left lg:py-8"
              >
                <span className="text-[13px] text-brand-text">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1">
                  <span className="block text-[22px] font-medium leading-[26px] tracking-[-0.8px] transition-colors duration-300 group-hover:text-brand-text lg:text-[32px] lg:leading-[36px] lg:tracking-[-1.2px]">
                    {vacancy.title}
                  </span>
                  <span className="body-12 mt-2 block text-muted-foreground">
                    {vacancy.format}
                  </span>
                </span>
                <span
                  aria-hidden="true"
                  className={`shrink-0 text-[20px] text-brand-text transition-transform duration-300 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  +
                </span>
              </button>

              <div
                className={`grid transition-all duration-300 ${
                  isOpen ? "grid-rows-[1fr] pb-6 lg:pb-9" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="body-12 max-w-[720px] text-muted-foreground">
                    {vacancy.lead}
                  </p>
                  <div className="mt-5 grid gap-6 lg:grid-cols-2 lg:gap-[60px]">
                    <div>
                      <div className="text-[12px] uppercase tracking-[0.08em] text-muted-foreground">
                        Задачи
                      </div>
                      <ul className="body-12 mt-3 space-y-2">
                        {vacancy.tasks.map((task) => (
                          <li key={task} className="flex gap-2">
                            <span aria-hidden="true" className="text-brand-text">
                              —
                            </span>
                            <span>{task}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div className="text-[12px] uppercase tracking-[0.08em] text-muted-foreground">
                        Ждём от вас
                      </div>
                      <ul className="body-12 mt-3 space-y-2">
                        {vacancy.skills.map((skill) => (
                          <li key={skill} className="flex gap-2">
                            <span aria-hidden="true" className="text-brand-text">
                              —
                            </span>
                            <span>{skill}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <a
                    href="#vacancy-form"
                    className="btn-label mt-6 inline-flex h-[48px] items-center justify-center bg-brand px-8 text-brand-foreground transition-colors duration-300 hover:bg-foreground hover:text-background"
                  >
                    Откликнуться на «{vacancy.title}»
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
